import { useEffect, useState } from "react";

const refreshIntervalMs = 60_000;

export function useCurrentDate() {
  const [currentDate, setCurrentDate] = useState(() => new Date());

  useEffect(() => {
    const refresh = () => setCurrentDate(new Date());
    const interval = window.setInterval(refresh, refreshIntervalMs);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);

    return () => {
      window.clearInterval(interval);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);

  return currentDate;
}
